import React, { useRef, useState } from 'react'
import classNames from 'classnames'

const ArrowIcon = ({ ...props }) => {
    return (
        <svg
            {...props}
            className={classNames("h-4 w-4", props?.className)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
            />
        </svg>
    )
}

const Accordion = ({ children }) => {
    return (
        <div className="flex flex-col items-center justify-center">
            {children}
        </div>
    )
}

Accordion.Panel = ({ children, title, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);

    const panelClassName = classNames('flex', props?.className);

    return (
        <div className="w-full">
            <div {...props} onClick={() => setIsOpen(!isOpen)} className={panelClassName}>
                <h3>{title}</h3>
                <ArrowIcon className={classNames({ "rotate-180": isOpen })} />
            </div>

            {React.cloneElement(children, { ...children.props, isOpen })}
        </div>
    )

}

Accordion.Content = ({ children, isOpen }) => {
    const containerRef = useRef(null);

    const style = {
        height: isOpen ? containerRef.current.scrollHeight + 'px' : '0px',
        transition: 'height ease 0.4s'
    }

    return (
        <div ref={containerRef} style={style} className="overflow-hidden bg-grey-lighter">
            {children}
        </div>
    )
}

export default Accordion
